function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "inquiryTitle"
}, "inquiry");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0,0.28017 L0,56.99892 L37.125,56.99892 C39.40299,56.99892 41.25,55.15191 41.25,52.87392 L41.25,52.87392 L41.25,0.28017 L0,0.28017 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0.28017 L0,52.87392 C0,55.15191 1.84734,56.99892 4.125,56.99892 L4.125,56.99892 L41.25,56.99892 L41.25,0.28017",
  id: "path-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0.28017 L0,52.87392 C0,55.15191 1.84734,56.99892 4.125,56.99892 L4.125,56.99892 L41.25,56.99892 L41.25,0.28017 L0,0.28017 Z",
  id: "path-5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-7",
  points: "0.165 61.94892 41.41434 61.94892 41.41434 0.07359 0.165 0.07359"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-1356.000000, -1064.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Detailed_Icon_Inquiry",
  transform: "translate(1356.000000, 1064.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-11",
  x: 0,
  y: 0,
  width: 180,
  height: 180
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(32.000000, 32.091080)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M99,0.23892 L16.5,0.23892 C7.38738,0.23892 0,7.6263 0,16.73892 L0,29.11392 C0,38.22654 7.38738,45.61392 16.5,45.61392 L24.75,53.86392 L33,45.61392 L49.5,45.61392 L57.75,53.86392 L66,45.61392 L82.5,45.61392 L90.75,53.86392 L99,45.61392 C108.11262,45.61392 115.5,38.22654 115.5,29.11392 L115.5,16.73892 C115.5,7.6263 108.11262,0.23892 99,0.23892",
  id: "Fill-1",
  fill: "#E8E6EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.1875,33.23892 C35.77035,33.23892 33,30.46857 33,27.05142 C33,23.63427 35.77035,20.86392 39.1875,20.86392 C42.60465,20.86392 45.375,23.63427 45.375,27.05142 C45.375,30.46857 42.60465,33.23892 39.1875,33.23892",
  id: "Fill-3",
  fill: "#5F5984"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.75,24.98892 C54.33285,24.98892 51.5625,22.21857 51.5625,18.80142 C51.5625,15.38427 54.33285,12.61392 57.75,12.61392 C61.16715,12.61392 63.9375,15.38427 63.9375,18.80142 C63.9375,22.21857 61.16715,24.98892 57.75,24.98892",
  id: "Fill-5",
  fill: "#5F5984"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.3125,33.23892 C72.89535,33.23892 70.125,30.46857 70.125,27.05142 C70.125,23.63427 72.89535,20.86392 76.3125,20.86392 C79.72965,20.86392 82.5,23.63427 82.5,27.05142 C82.5,30.46857 79.72965,33.23892 76.3125,33.23892",
  id: "Fill-7",
  fill: "#5F5984"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(106.250000, 90.831080)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-11"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#403C6C",
  mask: "url(#mask-2)",
  points: "13.2825 82.19541 27.96783 82.19541 27.96783 56.14092 13.2825 56.14092"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.185697,36.054546 L27.185697,36.075666 C27.192627,36.077976 27.199227,36.080286 27.206157,36.082266 L27.185697,36.054546 Z",
  id: "Fill-12",
  fill: "#474272",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#E8E6EE",
  mask: "url(#mask-2)",
  points: "14.25435 71.05329 26.99697 71.05329 26.99697 30.15276 14.25435 30.15276"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14",
  fill: "#403C6C",
  mask: "url(#mask-2)",
  points: "23.849595 62.15517 21.027105 37.0755 23.855865 32.75679 17.226495 32.75679 20.054925 37.0755 17.232105 62.15517 17.226495 62.15517 20.541015 65.42448 23.855865 62.15517"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-15",
  fill: "#E8E6EE",
  mask: "url(#mask-2)",
  points: "20.579889 32.04234 18.201909 35.71359 14.523729 30.69165"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-16",
  fill: "#E8E6EE",
  mask: "url(#mask-2)",
  points: "20.579889 32.04234 22.957869 35.71359 26.635719 30.69165"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.271947,35.931786 C2.396757,38.646036 -3.3e-05,43.737606 -3.3e-05,49.256526 L-3.3e-05,76.496376 L0.010197,76.496376 C0.007227,76.565346 -3.3e-05,76.633326 -3.3e-05,76.703286 C-3.3e-05,79.023186 1.880637,80.903856 4.200537,80.903856 C5.586867,80.903856 6.812487,80.229336 7.577427,79.193796 C8.353587,80.980416 9.874887,82.195146 11.626197,82.195146 L14.523927,82.195146 L14.523927,30.152496 L6.271947,35.931786 Z",
  id: "Fill-17",
  fill: "#5F5984",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.25,49.256823 C41.25,43.737243 38.83044,38.646333 34.91763,35.931753 L26.58546,30.152133 L26.58546,82.195113 L29.51157,82.195113 C31.3005,82.195113 32.84985,80.950683 33.62469,79.129413 C34.38534,80.201583 35.63439,80.903493 37.04943,80.903493 C39.36933,80.903493 41.25,79.023153 41.25,76.703583 C41.25,76.633623 41.24307,76.565643 41.23977,76.496673 L41.25,76.496673 L41.25,49.256823 Z",
  id: "Fill-18",
  fill: "#5F5984",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.46059,2.182488 C23.24256,1.714218 21.92388,1.446918 20.54085,1.446918 C14.49987,1.446918 9.60267,6.343788 9.60267,12.385098 C9.60267,18.426408 14.49987,23.323278 20.54085,23.323278 C21.92388,23.323278 23.24256,23.056308 24.46059,22.587378 C28.56282,21.010308 31.47936,17.042718 31.47936,12.385098 C31.47936,7.727478 28.56282,3.759888 24.46059,2.182488",
  id: "Fill-19",
  fill: "#847C9F",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.687096,16.262598 L30.687096,14.339358 C30.687096,8.782488 26.182266,4.277658 20.625396,4.277658 C15.068196,4.277658 10.563366,8.782488 10.563366,14.339358 L10.563366,16.262598 C9.317946,16.262598 8.308806,17.272068 8.308806,18.517158 C8.308806,19.761918 9.317946,20.771718 10.563366,20.771718 L10.563366,22.694628 C10.563366,28.251828 15.068196,32.756658 20.625396,32.756658 C26.182266,32.756658 30.687096,28.251828 30.687096,22.694628 L30.687096,20.771718 C31.932186,20.771718 32.941656,19.761918 32.941656,18.517158 C32.941656,17.272068 31.932186,16.262598 30.687096,16.262598",
  id: "Fill-20",
  fill: "#AAA3BD",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.46059,2.182488 C23.24256,1.714548 21.92388,1.446588 20.54085,1.446588 C18.04011,1.446588 15.74265,2.295348 13.90026,3.707418 C14.08209,6.232908 15.66576,8.367678 17.88138,9.333588 C18.69681,9.688998 19.59507,9.888978 20.54085,9.888978 C24.05766,9.888978 26.9313,7.163508 27.18177,3.710388 C26.35776,3.080418 25.44465,2.560668 24.46059,2.182488",
  id: "Fill-21",
  fill: "#847C9F",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-35",
  transform: "translate(32.000000, 90.831080)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-25"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.116323,13.505943 C34.612743,13.312233 34.067913,13.201683 33.496353,13.201683 C33.268323,13.201683 33.045903,13.224123 32.827113,13.256463 C32.478633,8.274123 29.234403,4.098633 24.767523,2.380983 C23.362713,1.840773 21.842403,1.532553 20.247183,1.532553 C13.280553,1.532553 7.632933,7.180173 7.632933,14.146803 C7.632933,21.114093 13.280553,26.761383 20.247183,26.761383 C21.842403,26.761383 23.362713,26.452833 24.767523,25.912953 C27.177513,24.985983 29.229123,23.341593 30.665613,21.243123 C31.440453,21.867153 32.424183,22.242363 33.496353,22.242363 C34.067913,22.242363 34.612743,22.132143 35.116323,21.938433 C36.811533,21.286353 38.016693,19.646583 38.016693,17.721693 C38.016693,15.796803 36.811533,14.158023 35.116323,13.505943",
  id: "Fill-23",
  fill: "#847C9F",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-27"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-26",
  fill: "#D2CFDD",
  mask: "url(#mask-6)",
  points: "11.65857 79.2594 28.49286 79.2594 28.49286 51.69153 11.65857 51.69153"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.684229,32.004324 C26.487219,31.943934 26.295489,31.871334 26.095839,31.816554 L23.454849,34.457214 L20.247249,37.665144 L17.039319,34.457214 L14.565639,31.983534 L14.565639,34.908984 L14.565639,51.691464 L26.684229,51.691464 L26.684229,34.908984 L26.684229,32.004324 Z",
  id: "Fill-28",
  fill: "#E8E6EE",
  mask: "url(#mask-6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.684229,31.983369 L26.684229,32.004159 C26.691159,32.006139 26.697759,32.008779 26.704689,32.010759 L26.684229,31.983369 Z",
  id: "Fill-29",
  fill: "#474272",
  mask: "url(#mask-6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.77706,25.551933 C24.82821,25.596153 24.88035,25.639713 24.93282,25.682613 C24.88035,25.639383 24.82821,25.596483 24.77706,25.551933 M25.48986,26.121843 C25.55388,26.169033 25.61691,26.217873 25.68192,26.263743 C25.61724,26.217873 25.55388,26.169033 25.48986,26.121843 M20.63919,16.924413 L20.63919,16.924083 C20.63424,16.783173 20.625,16.642593 20.625,16.499373 C20.625,16.642593 20.63424,16.783173 20.63919,16.924413 M26.43333,6.238023 C24.62526,5.145393 22.51359,4.505523 20.24715,4.505523 C13.62306,4.505523 8.2533,9.875283 8.2533,16.499373 C8.2533,22.011363 11.97537,26.642583 17.03955,28.047063 L17.03955,31.393923 C16.19673,31.541763 15.37008,31.736133 14.56587,31.983303 L17.03955,34.456983 L20.24715,37.664913 L23.45508,34.456983 L26.09574,31.816323 C25.23675,31.580373 24.35532,31.398873 23.45508,31.275123 L23.45508,28.051023 C24.51306,27.754683 25.51263,27.317763 26.43333,26.761713 C29.90955,24.660933 32.24133,20.857353 32.24133,16.499373 C32.24133,12.141393 29.90955,8.338473 26.43333,6.238023",
  id: "Fill-30",
  fill: "#D2CFDD",
  mask: "url(#mask-6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,51.69153 L0,71.8674 L0.0099,71.8674 C0.0099,74.14374 1.85526,75.9891 4.13193,75.9891 C4.33455,75.9891 4.53255,75.9693 4.72758,75.94092 C6.05088,77.93973 8.31666,79.2594 10.89297,79.2594 L14.55564,79.2594 L14.55564,51.69153 L14.55564,34.90905 L14.55564,31.9836 C6.12777,34.57146 0,42.4149 0,51.69153",
  id: "Fill-31",
  fill: "#5F5984",
  mask: "url(#mask-6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.694558,31.983369 L26.694558,34.908819 L26.694558,51.691629 L26.694558,79.259499 L30.357228,79.259499 C32.925618,79.259499 35.186118,77.948079 36.511068,75.960159 C36.666168,75.977649 36.823248,75.989199 36.983298,75.989199 C39.259308,75.989199 41.104668,74.143839 41.104668,71.867169 L41.249868,71.867169 L41.249868,51.691629 C41.249868,42.414669 35.122428,34.571559 26.694558,31.983369",
  id: "Fill-32",
  fill: "#5F5984",
  mask: "url(#mask-6)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-33",
  fill: "#403C6C",
  mask: "url(#mask-6)",
  points: "17.063013 40.850502 20.247183 37.666332 18.822573 36.241722 15.638733 39.425892 17.032653 39.514002"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-34",
  fill: "#403C6C",
  mask: "url(#mask-6)",
  points: "23.431287 40.850502 20.247447 37.666332 21.671727 36.241722 24.855897 39.425892 23.461977 39.514002"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-49",
  transform: "translate(68.960000, 85.881080)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.62559,5.731605 C23.40756,5.263335 22.08888,4.995705 20.70585,4.995705 C14.66487,4.995705 9.76767,9.892905 9.76767,15.934215 C9.76767,21.975195 14.66487,26.872395 20.70585,26.872395 C22.08888,26.872395 23.40756,26.605095 24.62559,26.136495 C28.72782,24.559095 31.64436,20.591835 31.64436,15.934215 C31.64436,11.276265 28.72782,7.309005 24.62559,5.731605",
  id: "Fill-36",
  fill: "#5F5984"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-39"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-38",
  fill: "#403C6C",
  mask: "url(#mask-8)",
  points: "13.5465 87.45 28.03383 87.45 28.03383 61.39518 13.5465 61.39518"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.520921,37.297227 L17.520921,40.708437 C16.661601,40.859247 15.819441,41.057577 14.999391,41.309037 L17.520921,43.830567 L20.789901,47.099547 L24.058881,43.830567 L26.751021,41.139087 C25.874541,40.898187 24.976941,40.713717 24.058881,40.587327 L24.058881,37.301847",
  id: "Fill-40",
  fill: "#615A85",
  mask: "url(#mask-8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.350697,41.309433 L27.350697,41.330223 C27.357627,41.332533 27.364227,41.335173 27.371157,41.337483 L27.350697,41.309433 Z",
  id: "Fill-41",
  fill: "#474272",
  mask: "url(#mask-8)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-42",
  fill: "#E8E6EE",
  mask: "url(#mask-8)",
  points: "14.41902 76.30821 27.16197 76.30821 27.16197 35.40768 14.41902 35.40768"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-43",
  fill: "#403C6C",
  mask: "url(#mask-8)",
  points: "24.053568 66.695904 21.230748 41.616234 24.059508 37.297194 17.430138 37.297194 20.258568 41.616234 17.436078 66.695904 17.430138 66.695904 20.744988 69.964884 24.059508 66.695904"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.165,54.511017 L0.165,81.751197 L0.17523,81.751197 C0.17193,81.820167 0.165,81.888147 0.165,81.958107 C0.165,84.277677 2.04567,86.158347 4.36557,86.158347 C5.7519,86.158347 6.97752,85.483827 7.74246,84.448617 C8.51829,86.235237 10.03992,87.449637 11.7909,87.449637 L14.68896,87.449637 L14.68896,35.406987 L6.43698,41.186277 C2.56179,43.900857 0.165,48.992097 0.165,54.511017",
  id: "Fill-44",
  fill: "#847C9F",
  mask: "url(#mask-8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.415,54.511347 C41.415,48.992097 38.99511,43.900857 35.08263,41.186607 L26.75046,35.407317 L26.75046,87.449967 L29.67657,87.449967 C31.4655,87.449967 33.01485,86.205207 33.78969,84.384267 C34.55034,85.456437 35.79906,86.158677 37.21443,86.158677 C39.53433,86.158677 41.415,84.278007 41.415,81.958107 C41.415,81.888147 41.40807,81.820167 41.40477,81.751197 L41.415,81.751197 L41.415,54.511347 Z",
  id: "Fill-45",
  fill: "#847C9F",
  mask: "url(#mask-8)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-46",
  fill: "#E8E6EE",
  mask: "url(#mask-8)",
  points: "20.744889 37.297227 18.366909 40.968477 14.688729 35.946867"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-47",
  fill: "#E8E6EE",
  mask: "url(#mask-8)",
  points: "20.744889 37.297227 23.122869 40.968477 26.800719 35.946867"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.106656,23.771715 C33.106656,22.526955 32.097186,21.517485 30.852096,21.517485 L30.852096,19.594575 L30.852096,19.590615 C30.852096,19.395585 30.844836,19.202205 30.833946,19.009815 C30.830646,18.950415 30.825036,18.891345 30.820416,18.831285 C30.810186,18.695325 30.797976,18.560025 30.782466,18.426045 C30.775206,18.361695 30.766626,18.298005 30.758046,18.234645 C30.739566,18.098685 30.718446,17.963055 30.694356,17.829075 C30.685116,17.775615 30.676536,17.721825 30.665976,17.669025 C30.631986,17.492805 30.593706,17.317245 30.550476,17.144325 C30.548496,17.136735 30.546846,17.128485 30.544866,17.120895 C30.495366,16.925535 30.439926,16.732485 30.379206,16.542075 C30.377886,16.537785 30.376566,16.533495 30.375246,16.529865 C30.317496,16.348695 30.253476,16.170495 30.186156,15.994275 C30.178236,15.973485 30.169986,15.953355 30.161736,15.932565 C30.095736,15.763605 30.025446,15.597285 29.950866,15.432615 C29.946246,15.422715 29.941956,15.413145 29.937336,15.403575 C28.347726,11.939565 24.851046,9.532545 20.790396,9.532545 C15.233196,9.532545 10.728366,14.037375 10.728366,19.594575 L10.728366,21.517485 C9.482946,21.517485 8.473476,22.526955 8.473476,23.771715 C8.473476,25.016805 9.482946,26.026275 10.728366,26.026275 L10.728366,27.949185 C10.728366,33.506385 15.233196,38.011215 20.790396,38.011215 C24.851706,38.011215 28.348716,35.603535 29.937996,32.138535 C29.941956,32.129955 29.945916,32.121705 29.949876,32.113125 C30.025116,31.947465 30.096066,31.779825 30.162726,31.608885 C30.170646,31.589415 30.178236,31.570275 30.185496,31.550475 C30.253476,31.372935 30.318156,31.193415 30.376236,31.010925 C30.377226,31.008615 30.378216,31.005645 30.378876,31.002345 C30.439926,30.811275 30.495366,30.618225 30.544866,30.422205 C30.546846,30.415605 30.548166,30.408015 30.549816,30.401415 C30.593376,30.227505 30.631656,30.051615 30.665976,29.874405 C30.676536,29.821605 30.685116,29.768475 30.694356,29.715015 C30.718446,29.580705 30.739566,29.445075 30.758376,29.308785 C30.766626,29.245425 30.775206,29.182065 30.782466,29.117715 C30.797976,28.983735 30.810186,28.848105 30.820416,28.712145 C30.825036,28.652415 30.830646,28.593345 30.833946,28.533945 C30.844836,28.341555 30.852096,28.147845 30.852096,27.952815 L30.852096,27.949185 L30.852096,26.026275 C32.097186,26.026275 33.106656,25.016805 33.106656,23.771715",
  id: "Fill-48",
  fill: "#847C9F",
  mask: "url(#mask-8)"
})))));

var SvgDetailedIconInquiry = function SvgDetailedIconInquiry(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    "aria-labelledby": "inquiryTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "inquiryTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetailedIconInquiry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/detailed-icon-inquiry.e9525ed7.svg";
export { ForwardRef as ReactComponent };